<template>
    <div class="card-data">
        <div class="card-title">
            <h4>{{title}}</h4>
            <small v-if="sub">{{sub}}</small>
        </div>
        <div class="right" id="percentage">
            <ICountUp
                :endVal="total"
                :options="options"
                />
            %
        </div>
    </div>
</template>

<script>
import ICountUp from 'vue-countup-v2'
import Loader from '@/components/Loader'

export default {
    name: 'EngagementCard',
    components: {
        ICountUp,
        Loader
    },
    props: {
        title: {
            type: String,
            required: true
        },
        sub: {
            type: String,
            required: false
        },
        total: {
            type: Number,
            required: true
        }
    },
    data: function(){
        return {
            options: {
                useEasing: true,
                useGrouping: true,
                duration: 0.6,
                separator: ',',
                decimal: '.',
                prefix: '',
                suffix: ''
            }
        }
    }
}
</script>

<style lang="sass">
#percentage
    font-family: Montserrat
    font-size: 32px
    font-weight: 600
    color: #302f2f
    margin-bottom: 8px
</style>